module.exports = __webpack_public_path__ + "img/members-icon.43c0b6eb.svg";